import { FC } from "react";
import Head from "next/head";
import { NavBar } from "@/components/navbar";
import { Footer } from "@/components/ui";
import styled from "styled-components";

type HomeLayoutProps = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  navbarTheme?: string;
  bgTheme?: string;
};

const MainLayoutContainer = styled.div<{ bgTheme?: string }>`
  background-color: ${({ bgTheme }) => (bgTheme ? bgTheme : "")};
`;

export const MainLayout: FC<HomeLayoutProps> = ({
  children,
  title,
  description,
  className,
  navbarTheme,
  bgTheme,
}) => {
  return (
    <>
      <Head>
        <title>{title || "Cellect Energy"}</title>
        <meta
          name="description"
          content={
            description ||
            "Cellect is a platform that helps you to optimize your business"
          }
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/cellect.ico" />
      </Head>
      <MainLayoutContainer bgTheme={bgTheme} className={className}>
        <NavBar navbarTheme={navbarTheme} />
        {children}
      </MainLayoutContainer>
      <Footer />
    </>
  );
};
